import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './PlatformSwitcher.module.scss'

const CodinGame: React.FC = () => {
  const t = useIntl()

  function handleClick () {
    if (window.scrollY > 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      location.reload()
    }
  }

  return (
    <a
      className={styles.externalLink}
      onClick={() => handleClick()}
    >
      <div className={styles.platformIntro}>
        {t.formatMessage({ id: 'platformSwitcher.developers' })}
      </div>
      <div className={styles.platformName}>
        <span>
          Codin
        </span><span style={{ color: '#F0B511' }}>Game</span>
      </div>
    </a>
  )
}

export default CodinGame
